// Built-in 5×7 bitmap font (uppercase, digits, punctuation, ÅÄÖÉ), drawn from
// a cached glyph atlas per colour so text stays pixel-exact at low resolution.

export const GLYPH_W = 5;
export const GLYPH_H = 7;
export const ADVANCE = 6;
export const LINE_H = 9;

// Each glyph is 7 rows of 5 bits, most significant bit = leftmost pixel.
const G: Record<string, number[]> = {
  ' ': [0, 0, 0, 0, 0, 0, 0],
  A: [0x0e, 0x11, 0x11, 0x11, 0x1f, 0x11, 0x11],
  B: [0x1e, 0x11, 0x11, 0x1e, 0x11, 0x11, 0x1e],
  C: [0x0e, 0x11, 0x10, 0x10, 0x10, 0x11, 0x0e],
  D: [0x1c, 0x12, 0x11, 0x11, 0x11, 0x12, 0x1c],
  E: [0x1f, 0x10, 0x10, 0x1e, 0x10, 0x10, 0x1f],
  F: [0x1f, 0x10, 0x10, 0x1e, 0x10, 0x10, 0x10],
  G: [0x0e, 0x11, 0x10, 0x17, 0x11, 0x11, 0x0f],
  H: [0x11, 0x11, 0x11, 0x1f, 0x11, 0x11, 0x11],
  I: [0x0e, 0x04, 0x04, 0x04, 0x04, 0x04, 0x0e],
  J: [0x07, 0x02, 0x02, 0x02, 0x02, 0x12, 0x0c],
  K: [0x11, 0x12, 0x14, 0x18, 0x14, 0x12, 0x11],
  L: [0x10, 0x10, 0x10, 0x10, 0x10, 0x10, 0x1f],
  M: [0x11, 0x1b, 0x15, 0x15, 0x11, 0x11, 0x11],
  N: [0x11, 0x11, 0x19, 0x15, 0x13, 0x11, 0x11],
  O: [0x0e, 0x11, 0x11, 0x11, 0x11, 0x11, 0x0e],
  P: [0x1e, 0x11, 0x11, 0x1e, 0x10, 0x10, 0x10],
  Q: [0x0e, 0x11, 0x11, 0x11, 0x15, 0x12, 0x0d],
  R: [0x1e, 0x11, 0x11, 0x1e, 0x14, 0x12, 0x11],
  S: [0x0f, 0x10, 0x10, 0x0e, 0x01, 0x01, 0x1e],
  T: [0x1f, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04],
  U: [0x11, 0x11, 0x11, 0x11, 0x11, 0x11, 0x0e],
  V: [0x11, 0x11, 0x11, 0x11, 0x11, 0x0a, 0x04],
  W: [0x11, 0x11, 0x11, 0x15, 0x15, 0x15, 0x0a],
  X: [0x11, 0x11, 0x0a, 0x04, 0x0a, 0x11, 0x11],
  Y: [0x11, 0x11, 0x11, 0x0a, 0x04, 0x04, 0x04],
  Z: [0x1f, 0x01, 0x02, 0x04, 0x08, 0x10, 0x1f],
  Å: [0x04, 0x0a, 0x04, 0x0e, 0x11, 0x1f, 0x11],
  Ä: [0x0a, 0x00, 0x0e, 0x11, 0x1f, 0x11, 0x11],
  Ö: [0x0a, 0x00, 0x0e, 0x11, 0x11, 0x11, 0x0e],
  É: [0x02, 0x04, 0x1f, 0x10, 0x1e, 0x10, 0x1f],
  Ü: [0x0a, 0x00, 0x11, 0x11, 0x11, 0x11, 0x0e],
  0: [0x0e, 0x11, 0x13, 0x15, 0x19, 0x11, 0x0e],
  1: [0x04, 0x0c, 0x04, 0x04, 0x04, 0x04, 0x0e],
  2: [0x0e, 0x11, 0x01, 0x02, 0x04, 0x08, 0x1f],
  3: [0x1f, 0x02, 0x04, 0x02, 0x01, 0x11, 0x0e],
  4: [0x02, 0x06, 0x0a, 0x12, 0x1f, 0x02, 0x02],
  5: [0x1f, 0x10, 0x1e, 0x01, 0x01, 0x11, 0x0e],
  6: [0x06, 0x08, 0x10, 0x1e, 0x11, 0x11, 0x0e],
  7: [0x1f, 0x01, 0x02, 0x04, 0x08, 0x08, 0x08],
  8: [0x0e, 0x11, 0x11, 0x0e, 0x11, 0x11, 0x0e],
  9: [0x0e, 0x11, 0x11, 0x0f, 0x01, 0x02, 0x0c],
  '!': [0x04, 0x04, 0x04, 0x04, 0x04, 0x00, 0x04],
  '"': [0x0a, 0x0a, 0x00, 0x00, 0x00, 0x00, 0x00],
  '#': [0x0a, 0x0a, 0x1f, 0x0a, 0x1f, 0x0a, 0x0a],
  $: [0x04, 0x0f, 0x14, 0x0e, 0x05, 0x1e, 0x04],
  '%': [0x18, 0x19, 0x02, 0x04, 0x08, 0x13, 0x03],
  '&': [0x0c, 0x12, 0x14, 0x08, 0x15, 0x12, 0x0d],
  "'": [0x04, 0x04, 0x08, 0x00, 0x00, 0x00, 0x00],
  '(': [0x02, 0x04, 0x08, 0x08, 0x08, 0x04, 0x02],
  ')': [0x08, 0x04, 0x02, 0x02, 0x02, 0x04, 0x08],
  '*': [0x00, 0x04, 0x15, 0x0e, 0x15, 0x04, 0x00],
  '+': [0x00, 0x04, 0x04, 0x1f, 0x04, 0x04, 0x00],
  ',': [0x00, 0x00, 0x00, 0x00, 0x0c, 0x04, 0x08],
  '-': [0x00, 0x00, 0x00, 0x1f, 0x00, 0x00, 0x00],
  '.': [0x00, 0x00, 0x00, 0x00, 0x00, 0x0c, 0x0c],
  '/': [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x00],
  ':': [0x00, 0x0c, 0x0c, 0x00, 0x0c, 0x0c, 0x00],
  ';': [0x00, 0x0c, 0x0c, 0x00, 0x0c, 0x04, 0x08],
  '<': [0x02, 0x04, 0x08, 0x10, 0x08, 0x04, 0x02],
  '=': [0x00, 0x00, 0x1f, 0x00, 0x1f, 0x00, 0x00],
  '>': [0x08, 0x04, 0x02, 0x01, 0x02, 0x04, 0x08],
  '?': [0x0e, 0x11, 0x01, 0x02, 0x04, 0x00, 0x04],
  '@': [0x0e, 0x11, 0x01, 0x0d, 0x15, 0x15, 0x0e],
  '[': [0x0e, 0x08, 0x08, 0x08, 0x08, 0x08, 0x0e],
  ']': [0x0e, 0x02, 0x02, 0x02, 0x02, 0x02, 0x0e],
  _: [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x1f],
  '°': [0x0c, 0x12, 0x12, 0x0c, 0x00, 0x00, 0x00],
  '↑': [0x04, 0x0e, 0x15, 0x04, 0x04, 0x04, 0x04],
  '↓': [0x04, 0x04, 0x04, 0x04, 0x15, 0x0e, 0x04],
  '←': [0x00, 0x04, 0x08, 0x1f, 0x08, 0x04, 0x00],
  '→': [0x00, 0x04, 0x02, 0x1f, 0x02, 0x04, 0x00],
  '■': [0x00, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x00],
  '□': [0x00, 0x1f, 0x11, 0x11, 0x11, 0x1f, 0x00],
  '♪': [0x06, 0x05, 0x04, 0x04, 0x1c, 0x1c, 0x00],
};

const CHARS = Object.keys(G);
const INDEX = new Map(CHARS.map((c, i) => [c, i]));
const atlases = new Map<string, HTMLCanvasElement>();
let mask: HTMLCanvasElement | null = null;

function glyphMask(): HTMLCanvasElement {
  if (mask) return mask;
  mask = document.createElement('canvas');
  mask.width = CHARS.length * ADVANCE;
  mask.height = GLYPH_H;
  const ctx = mask.getContext('2d')!;
  ctx.fillStyle = '#fff';
  CHARS.forEach((ch, i) => {
    G[ch].forEach((row, y) => {
      for (let x = 0; x < GLYPH_W; x++) {
        if (row & (1 << (GLYPH_W - 1 - x))) ctx.fillRect(i * ADVANCE + x, y, 1, 1);
      }
    });
  });
  return mask;
}

function atlas(color: string): HTMLCanvasElement {
  let a = atlases.get(color);
  if (a) return a;
  const m = glyphMask();
  a = document.createElement('canvas');
  a.width = m.width;
  a.height = m.height;
  const ctx = a.getContext('2d')!;
  ctx.drawImage(m, 0, 0);
  ctx.globalCompositeOperation = 'source-in';
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, a.width, a.height);
  atlases.set(color, a);
  return a;
}

export interface TextStyle {
  color?: string;
  /** Drop shadow colour (1 px down-right), or null for none. */
  shadow?: string | null;
  scale?: number;
  align?: 'left' | 'center' | 'right';
}

export function textWidth(text: string, scale = 1): number {
  return text.length > 0 ? (text.length * ADVANCE - 1) * scale : 0;
}

export function drawText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, style: TextStyle = {}): void {
  const scale = style.scale ?? 1;
  const upper = text.toUpperCase();
  let x0 = Math.round(x);
  const w = textWidth(upper, scale);
  if (style.align === 'center') x0 = Math.round(x - w / 2);
  else if (style.align === 'right') x0 = Math.round(x - w);
  const y0 = Math.round(y);
  const shadow = style.shadow === undefined ? '#000' : style.shadow;
  if (shadow) blit(ctx, upper, x0 + scale, y0 + scale, atlas(shadow), scale);
  blit(ctx, upper, x0, y0, atlas(style.color ?? '#fff'), scale);
}

function blit(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, img: HTMLCanvasElement, scale: number): void {
  for (let i = 0; i < text.length; i++) {
    const gi = INDEX.get(text[i]) ?? INDEX.get('?')!;
    ctx.drawImage(img, gi * ADVANCE, 0, GLYPH_W, GLYPH_H, x + i * ADVANCE * scale, y, GLYPH_W * scale, GLYPH_H * scale);
  }
}
